<template>
  <v-container>
    <v-layout row>
      <v-flex class="containerBanner" md10 lg10 xs12 sm11></v-flex>
    </v-layout>
    <v-layout row>
      <v-flex offset-xs0 offset-md1 offset-lg0 offset-sm0 md9 lg10 xs12 sm11>
        <v-flex class="containerStyle2" md12 lg12 xs12 sm12 v-if="typeEstrategico == '1' ">
          <v-layout>
            <v-flex md12 lg12 xs12 sm12>
              <h4 class="pull">Definición de acciones área {{this.area}}</h4>
            </v-flex>
          </v-layout>

          <v-layout>
            <v-flex md12 lg12 xs12 sm12>
              <label for="usr">Debilidades</label>
              <select class="form-control" id="5" v-model="debilidad" @change="debilidadF()" place-holder="asddsa">
                <option value selected disabled>-Selecciona una opción-</option>
                <option
                  v-for="(debilidad,index) in debilidades"
                  :key="index"
                  :value="debilidad"
                >{{debilidad.descripcion}}</option>
              </select>
            </v-flex>
          </v-layout>

          <v-layout>
            <v-flex md12 lg12 xs12 sm12>
              <label for="usr">Objetivos</label>
              <select class="form-control" id="5" v-model="objetivo"  @change="objetivoF()" place-holder="asddsa">
                <option value selected disabled>-Selecciona una opción-</option>
                <option
                  v-for="(objetivo,index) in objetivos"
                  :key="index"
                  :value="objetivo"
                >{{objetivo.descripcion}}</option>
              </select>
            </v-flex>
          </v-layout>

          <v-layout>
            <v-flex md12 lg12 xs12 sm12>
              <label for="usr">Estrategias</label>
              <select class="form-control" id="5" v-model="estrategia"  @change="estrategiaF()" place-holder="asddsa">
                <option value selected disabled>-Selecciona una opción-</option>
                <option
                  v-for="(estrategia,index) in estrategias"
                  :key="index"
                  :value="estrategia"
                >{{estrategia.descripcion}}</option>
              </select>
            </v-flex>
          </v-layout>
          <br />
          <v-layout >
            <v-flex md12 lg12 xs12 sm12>
              <table class="table table-striped header-fixed">
                <thead>
                  <tr>
                    <th
                      class="col-md-3 th-border"
                    >Unidad Responsable</th>
                     <th
                      class="col-md-9 th-border"
                    >{{estrategia.responsable}}</th>
                  </tr>
                  <tr>
                    <th
                      style="text-align: center"
                      :class="header.border"
                      v-for="(header,index) in headers"
                      :key="index"
                    >{{header.text}}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item,index) in acciones" :key="index">
                    <td style="text-align:left " :class="headers[0].size">{{item.descripcion}}</td>
                    <td style="text-align:left " :class="headers[1].size">{{item.resultado}}</td>
                    <td style="text-align:left " :class="headers[2].size">{{item.plazo}}</td>
                    <td style="text-align:left " :class="headers[3].size">{{item.recurso}}</td>
                    <td :class="headers[4].size">
                      <v-icon
                        :disabled="!($session.getAll().puedeEditar == true) "
                        small
                        class="mr-2"
                        @click="openEditPlan(item,index)"
                      >edit</v-icon>

                      <v-icon small class="mr-2" @click="viewDocument(item)">add</v-icon>
                    </td>
                  </tr>
                </tbody>
              </table>
            </v-flex>
          </v-layout>

        
        </v-flex>
      </v-flex>

    </v-layout>


    <v-layout>
      <v-dialog v-model="edit" width="600px" persistent>
        <v-card class="v-card-dialog" height="600px">
          <v-card-title>
            <span class="headline" >Editar Acción</span>
          </v-card-title>
          <v-flex offset-md1 offset-lg1 offset-xs1 offset-sm1 md10 lg10 xs10 sm10>
            <v-layout row>
            </v-layout>
            <v-layout row>
              <v-flex md12 lg12 xs12 sm12>
                <label for="usr">Nombre de acción de mejoramiento</label>
                <textarea
                  v-model="accion.descripcion"
                  type="text"
                  rows="1"
                  class="form-control"
                  id="usr"
                />
              </v-flex>
            </v-layout>
        

            <v-layout row>
              <v-flex md12 lg12 xs12 sm12>
                <label for="usr">Resultado esperado</label>
                <textarea
                  v-model="accion.resultado"
                  type="text"
                  rows="3"
                  class="form-control"
                  id="usr"
                />
              </v-flex>
            </v-layout>

            <v-layout row>
              <v-flex md12 lg12 xs12 sm12>
                <label for="usr">Plazos</label>
                <textarea
                  v-model="accion.plazo"
                  type="text"
                  rows="1"
                  class="form-control"
                  id="usr"
                />
              </v-flex>
            </v-layout>

            <v-layout row>
              <v-flex md12 lg12 xs12 sm12>
                <label for="usr">Recursos</label>
                <textarea
                  v-model="accion.recurso"
                  type="text"
                  rows="1"
                  class="form-control"
                  id="usr"
                />
              </v-flex>
            </v-layout>
          </v-flex>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="#ec6a12" flat="flat" @click="edit = false">Cerrar</v-btn>
            <v-btn color="#394049" flat="flat" @click="editPlan()">Guardar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout> 

  </v-container>
</template>

<script>
import img1 from "../../../assets/BANNER_7.png";
import img3 from "../../../assets/nuevaasistenciadca.png";
import planes from "../../util/planesv2.json";
export default {
  data() {
    return {
      area: "",
      nEtapa: 3,
      etapa: "",
      accion:"",
      acciones: [],
      estrategias: [],
      estrategia: "",
      debilidades: [],
      debilidad: "",
      objetivos: [],
      objetivo: "",
      img3: img3,
      edit: false,
      index: "",
      dialog: false,
      headers: [
        {
          text: "Acción de mejoramiento",
          value: "name",
          size: "col-md-3 col-lg-3 col-sm-3 col-xs-3",
          border: "col-md-3 col-lg-3 col-sm-3 col-xs-3 th-border"
        },

        {
          text: "Resultado Esperado",
          value: "muy desacuerdo",
          size: "col-md-3 col-lg-3 col-sm-3 col-xs-3",
          border: "col-md-3 col-lg-3 col-sm-3 col-xs-3 th-border"
        },
        {
          text: "Plazos",
          value: "desacuerdo",
          size: "col-md-2 col-lg-2 col-sm-2 col-xs-2",
          border: "col-md-2 col-lg-2 col-sm-2 col-xs-2 th-border"
        },
        {
          text: "Recursos",
          value: "desacuerdo",
          size: "col-md-3 col-lg-3 col-sm-3 col-xs-3",
          border: "col-md-3 col-lg-3 col-sm-3 col-xs-3 th-border"
        },
        {
          text: "Acciones",
          value: "desacuerdo",
          size: "col-md-1 col-lg-1 col-sm-1 col-xs-1",
          border: "col-md-1 col-lg-1 col-sm-1 col-xs-1 th-border"
        }
      ],
      headers2: [
        {
          text: "",
          value: "name",
          size: "col-md-2 col-lg-2 col-sm-2 col-xs-2"
        },

        {
          text: "",
          value: "muy desacuerdo",
          size: "col-md-3 col-lg-3 col-sm-3 col-xs-3"
        },
        {
          text: "",
          value: "desacuerdo",
          size: "col-md-2 col-lg-2 col-sm-2 col-xs-2"
        },
        {
          text: "",
          value: "desacuerdo",
          size: "col-md-1 col-lg-1 col-sm-1 col-xs-1"
        },
        {
          text: "Presupuesto / Año",
          value: "desacuerdo",
          size: "col-md-3 col-lg-3 col-sm-3 col-xs-3 th-border"
        },
        {
          text: "",
          value: "desacuerdo",
          size: "col-md-1 col-lg-1 col-sm-1 col-xs-1"
        }
      ],
      typeEstrategico: "1",
      auth: {
        headers: { Authorization: "" + this.$session.get("jwt") }
      },
      img1: img1,
      confirm: false,
      right: null
    };
  },

  created() {
    //console.log(this.$session.getAll().puedeEditar);
    // Con esto, me traera las debilidades
    this.initComponent()
    
    
  },

   watch: {
    // cuando 'question' cambie, se ejecutará esta función
    "$route.fullPath": function() {
      //console.log("whatcher a detectado un cambio en user");
      this.initComponent();
    }
  },
  methods: {
    viewDocument(item) {
      this.$router.push({ name: "documentosAcciones", params: { id: item.id } });
    },

    initComponent(){
      if (this.$route.params.id == "1" ) this.area = "Gestión";
      if (this.$route.params.id =="2") this.area = "Pregrado";
      if (this.$route.params.id =="3") this.area = "Postgrado";
      if (this.$route.params.id =="4") this.area = "Investigación";
      if (this.$route.params.id =="5") this.area = "Vinculación con el medio";
      axios
      .get(process.env.ROOT_API + "/debilidad/getAllByArea?area=" + this.$route.params.id, {
        headers: { Authorization: "" + this.$session.get("jwt") }
      })
      .then(response => {
        //console.log("debilidades");
        console.log(response.data);
        this.debilidades = response.data;
        this.debilidad = this.debilidades[0];
        // Con esto me traerá los objetivos
        axios
          .get(
            process.env.ROOT_API +
              "/objetivo/getAllByDebilidad?idDebilidad=" +
              this.debilidad.id,
            {
              headers: { Authorization: "" + this.$session.get("jwt") }
            }
          )
          .then(response => {
            console.log("Objetivos");
            console.log(response.data);
            this.objetivos = response.data;
            this.objetivo = this.objetivos[0];
            // Con esto me traerá las estrategias

            axios
              .get(
                process.env.ROOT_API +
                  "/estrategia/getAllByObjetivo?idObjetivo=" +
                  this.objetivo.id,
                {
                  headers: { Authorization: "" + this.$session.get("jwt") }
                }
              )
              .then(response => {
                console.log("Estrategias");
                console.log(response.data);
                this.estrategias = response.data;
                this.estrategia = this.estrategias[0];
                // Con esto me traerá las estrategias

                axios
                  .get(
                    process.env.ROOT_API +
                      "/accion/getAllEstrategia?idEstrategia=" +
                      this.estrategia.id,
                    {
                      headers: { Authorization: "" + this.$session.get("jwt") }
                    }
                  )
                  .then(response => {
                    console.log("acciones");
                    console.log(response.data);
                    this.acciones = response.data;
                    this.accion = this.acciones[0];
                    // Con esto me traerá las estrategias
                  })
                  .catch(error => {
                    console.error(error);
                  });
              })
              .catch(error => {
                console.error(error);
              });
          })
          .catch(error => {
            console.error(error);
          });
      })
      .catch(error => {
        console.error(error);
      });
    },


    openEditPlan(plan, index) {
      this.dialog = true
      this.edit = true;
      this.index = index;
      this.accion = plan;
      this.fechaInicio = plan.fechaInicio;
    },


    editPlan() {
      this.edit = false;
      const objetActividad = {
        actividad: this.plan,
      };
      axios
        .patch(
          process.env.ROOT_API + "/actividad/updateActividadv2",
          objetActividad,
          this.auth
        )
        .then(response => {
          //console.log(response.data)
          this.initComponent();
          alert("Acción Actualizada");
        })
        .catch(error => {
          console.error(error);
          this.initComponent();
          alert("Error:" + error);
        });
    },
    replaceT(texto) {
      var newTexto = texto.replace(/\n/g, "<br />");
      //console.log(newTexto);
      return newTexto;
    },



        debilidadF() {
      //console.log("whatcher a detectado un cambio en user");
      axios
        .get(
          process.env.ROOT_API +
            "/objetivo/getAllByDebilidad?idDebilidad=" +
            this.debilidad.id,
          {
            headers: { Authorization: "" + this.$session.get("jwt") }
          }
        )
        .then(response => {
          console.log("Objetivos");
          console.log(response.data);
          this.objetivos = response.data;
          this.objetivo = this.objetivos[0];
          // Con esto me traerá las estrategias

          axios
            .get(
              process.env.ROOT_API +
                "/estrategia/getAllByObjetivo?idObjetivo=" +
                this.objetivo.id,
              {
                headers: { Authorization: "" + this.$session.get("jwt") }
              }
            )
            .then(response => {
              console.log("Estrategias");
              console.log(response.data);
              this.estrategias = response.data;
              this.estrategia = this.estrategias[0];
              // Con esto me traerá las acciones
              axios
                .get(
                  process.env.ROOT_API +
                    "/accion/getAllEstrategia?idEstrategia=" +
                    this.estrategia.id,
                  {
                    headers: { Authorization: "" + this.$session.get("jwt") }
                  }
                )
                .then(response => {
                  console.log("acciones");
                  console.log(response.data);
                  this.acciones = response.data;
                  this.accion = this.acciones[0];
                  // Con esto me traerá las estrategias
                })
                .catch(error => {
                  console.error(error);
                });
            })
            .catch(error => {
              console.error(error);
            });
        })
        .catch(error => {
          console.error(error);
        });
    },

    objetivoF() {
      //console.log("whatcher a detectado un cambio en user");
      axios
        .get(
          process.env.ROOT_API +
            "/estrategia/getAllByObjetivo?idObjetivo=" +
            this.objetivo.id,
          {
            headers: { Authorization: "" + this.$session.get("jwt") }
          }
        )
        .then(response => {
          console.log("Estrategias");
          console.log(response.data);
          this.estrategias = response.data;
          this.estrategia = this.estrategias[0];
          // Con esto me traerá las acciones
          axios
            .get(
              process.env.ROOT_API +
                "/accion/getAllEstrategia?idEstrategia=" +
                this.estrategia.id,
              {
                headers: { Authorization: "" + this.$session.get("jwt") }
              }
            )
            .then(response => {
              console.log("acciones");
              console.log(response.data);
              this.acciones = response.data;
              this.accion = this.acciones[0];
              // Con esto me traerá las estrategias
            })
            .catch(error => {
              console.error(error);
            });
        })
        .catch(error => {
          console.error(error);
        });
    },

    estrategiaF(){
      //console.log("whatcher a detectado un cambio en user");

      axios
        .get(
          process.env.ROOT_API +
            "/accion/getAllEstrategia?idEstrategia=" +
            this.estrategia.id,
          {
            headers: { Authorization: "" + this.$session.get("jwt") }
          }
        )
        .then(response => {
          console.log("acciones");
          console.log(response.data);
          this.acciones = response.data;
          this.accion = this.acciones[0];
          // Con esto me traerá las estrategias
        })
        .catch(error => {
          console.error(error);
        });
    }
  }
};
</script>


<style scoped>
.v-card-dialog{
  height: auto!important;
}
.image {
  cursor: pointer;
}
.text-mision {
  color: rgb(255, 255, 255);
  font-size: 11px;
}

.titlep {
  color: #ec6a12;
  font-size: 12px;
}

.table2 {
  height: 100px !important;
}

.v-card-new {
  margin-top: 50px;
  margin-bottom: 3%;
  margin-left: 3%;
  padding-right: 15px;
  padding-left: 15px;
  padding-top: 0.5%;
  background: #394049 !important;
  height: 230px !important;
  overflow-y: auto;
}

.v-card {
  height: auto;
  overflow-y: auto;
}

.td-color {
  background: #394049;
  height: 100%;
}

.containerBanner {
  width: 100%;
  margin-top: 50px !important;
}

.drawner {
  width: 200px !important;
  height: 300px !important;
  margin-left: 15px !important;
  margin-top: 80px !important;
  text-decoration: none !important;
  background-color: #f1f1f1 !important;
  border-left: 1px solid black !important;
}

.drawner2 {
  width: 100% !important;
  height: 250px !important;

  text-decoration: none !important;
  background-color: #394049 !important;
}

.font {
  color: white !important;
}

.containerStyle2 {
  width: 100% !important;
  margin-top: 10px !important;
}
.video {
  width: 100% !important;
  margin-top: 10px !important;
  height: 400px;
}

.containerStyle1 {
  width: 100%;
  margin-top: 25%;
  margin-bottom: 50px;
}

.pull {
  text-align: justify;
}

.v-list-new {
  height: 100% !important;
}

.v-btn__content {
  font-size: 10px !important;
}

.theme--light.v-btn {
  color: white;
}

.v-list__tile__title {
  color: black !important;
}

.v-btn {
  font-size: 10px;
  border-radius: 50px;
}

.header-fixed {
  width: 100%;
}
.header-fixed > thead,
.header-fixed > tbody,
.header-fixed > thead > tr,
.header-fixed > tbody > tr,
.header-fixed > thead > tr > th,
.header-fixed > tbody > tr > td {
  display: block;
}
.header-fixed > tbody > tr:after,
.header-fixed > thead > tr:after {
  content: " ";
  display: block;
  visibility: hidden;
  clear: both;
}
.header-fixed > tbody {
  overflow-y: auto;
  height: 250px;
  width: 100%;
}

.header-fixed > tbody > tr > td,
.header-fixed > thead > tr > th {
  float: left;
  font-size: 11px;
  border-bottom: 0 !important;
}

.th-border {
  border: #ddd 1px solid !important;
}

.th {
  background-color: aqua !important;
}

/* width */
::-webkit-scrollbar {
  width: 3px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #888;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}
#myVideo {
  width: 100%;
  height: auto;
}
</style>


// WEBPACK FOOTER //
// src/components/dca/mejoramiento/Plan2.vue